import { StyleSheet } from "react-native";
import {useEffect, useState} from 'react';
import { Text, View } from "../components/Themed";
import AsyncStorage from "@react-native-async-storage/async-storage";
import i18n from "../utils/localization";
import {Picker} from '@react-native-picker/picker';
import PublicFooter from "../components/PublicFooter";

export default function MoreScreen() {
  const [locale, setLocale] = useState('auto');
  const defaultLocale = typeof i18n.getDefaultLocale === 'function' ? i18n.getDefaultLocale() : 'bg';

  useEffect(() => {
    async function fetchData() {
      try {
        const storedLocale = await AsyncStorage.getItem("locale");
        setLocale(storedLocale || 'auto');
      } catch (ex) {}
    }
    fetchData();
  }, []);


  return (
    <View style={styles.container}>
      <View style={styles.body}>
        <Text style={{fontSize: 20, padding: 20}}>Language:</Text>
        <Picker
          selectedValue={locale || 'auto'}
          onValueChange={async (itemValue, itemIndex) => {
            setLocale(itemValue);
            if (typeof i18n.setLocale === 'function') {
              await i18n.setLocale(itemValue);
            } else {
              i18n.locale = itemValue;
            }
          }}>
          <Picker.Item label={`Default (${String(defaultLocale).toUpperCase()})`} value="auto" />
          <Picker.Item label="English" value="en" />
          <Picker.Item label="Italiano" value="it" />
          <Picker.Item label="Български" value="bg" />
        </Picker>
      </View>
      <PublicFooter />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  body: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  title: {
    fontSize: 20,
    fontWeight: "bold",
  },
  separator: {
    marginVertical: 30,
    height: 1,
    width: "80%",
  },
});
